import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "../base/pd-base-ui-input.js";
import { PdBaseInputElement } from "../base/pd-base-input-element.js";
import { css, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { msg, str } from "@lit/localize";
//#region src/pd-input-area/PdInputArea.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Multiline textarea input component.
*
* @tagname pd-input-area
* @summary Multiline textarea with validation and form integration.
*
* @event validate-form - Fired when input value changes for validation.
* @event field-change - Fired when input value changes.
*
* @cssprop --pd-input-field-width - Textarea width. Default: `240px`.
* @cssprop --pd-input-field-height - Textarea height. Default: `2.2rem`.
* @cssprop --pd-input-field-padding - Textarea padding. Default: `0.25rem`.
* @cssprop --pd-input-field-bg-col - Background color. Default: `var(--pd-default-bg-col)`.
* @cssprop --pd-input-field-border - Border style. Default: `1px solid var(--pd-default-light-col)`.
* @cssprop --pd-input-field-border-bottom - Bottom border. Default: `2px solid var(--pd-default-col)`.
* @cssprop --pd-input-field-border-focus - Focus border. Default: `2px solid var(--pd-default-col)`.
* @cssprop --pd-input-field-border-col-hover - Hover border color. Default: `var(--pd-default-hover-col)`.
*/
var PdInputArea = class extends PdBaseInputElement {
	static {
		this.styles = [PdBaseInputElement.styles, css`
      /* override default width for area */
      .input-style {
        width: var(--pd-input-field-width, 240px);
      }
    `];
	}
	constructor() {
		super();
		this.rows = 2;
		this.maxlength = 500;
		this._inputType = 5;
	}
	connectedCallback() {
		this._setupValidators();
		super.connectedCallback();
	}
	_setupValidators() {
		const validators = [];
		if (this.minlength !== void 0) validators.push((value) => value.length < this.minlength ? msg(str`Mindestens ${this.minlength} Zeichen`) : null);
		if (this.maxlength !== void 0) validators.push((value) => value.length > this.maxlength ? msg(str`Maximal ${this.maxlength} Zeichen`) : null);
		this._validators = validators;
	}
	render() {
		const inputAreaId = `${this.id}InputArea`;
		const errorId = `${this.id}Error`;
		return html`
      ${this._renderLabel(inputAreaId)}
      <div
        class="${classMap(this.getClassmap({ input: true }))}"
      >
        <textarea
          id="${inputAreaId}"
          name="${this.name || this.valueName}"
          class="input-style ${this.gradient ? "gradient" : ""}"
          rows="${this.rows}"
          cols="${this.cols ?? ""}"
          placeholder="${this.placeHolder}"
          minlength="${this.minlength ?? ""}"
          maxlength="${this.maxlength ?? ""}"
          ?disabled="${this.disabled}"
          ?readonly="${this.readonly}"
          .value="${this.value}"
          aria-invalid="${this._invalid}"
          aria-describedby="${this._errorMsg ? errorId : ""}"
          @keyup="${this._onKeyUp}"
          @blur="${this._onBlur}"
          @focus="${this._onFocus}"
        ></textarea>
      </div>
      ${this._renderErrorMsg(errorId)}
    `;
	}
};
__decorate([property({ type: Number })], PdInputArea.prototype, "rows", void 0);
__decorate([property({ type: Number })], PdInputArea.prototype, "cols", void 0);
__decorate([property({ type: Number })], PdInputArea.prototype, "minlength", void 0);
__decorate([property({ type: Number })], PdInputArea.prototype, "maxlength", void 0);
//#endregion
export { PdInputArea };
